<!--
 * @Description: 人员审核情证书信息组件
 * @Author: gaohc
 * @Date: 2022-12-01 11:01:35
-->
<template>
  <div class="certInfo-wrap">
    <div class="header-wrap" :class="(reviewType == 7 || reviewType == 11) ? 'sticky' : ''">
      <div class="header" :style="{'align-items' : !isFold && (reviewType == 7 || reviewType == 11) ?  'flex-start' : 'center'}">
        <img class="header-image" src="../../../../assets/instmng/attendantlist/img-attendant-certinfo.png" alt="" />
        <div style="flex: 1">
          <span>电子证书</span>
          <div v-if="!isFold && (reviewType == 7 || reviewType == 11)" class="review-status-text-wrap">
            <span class="circle-dot" :class="currentCertificate.review.status == 2 ? 
              'refuse-status': 'routine-status'">
            </span>
            <span :class="currentCertificate.review.status == 2 ? 'refuse-text': 'routine-text'">
              {{currentCertificate.review.statusText}}
            </span>
          </div>
          <div v-if="!isFold && (reviewType == 7 || reviewType == 11)" class="review-text">
            <div v-if="currentCertificate.review.status == 0">
              <span>提交人：</span>
              <span>
                {{currentCertificate.review.submiterText ? 
                  currentCertificate.review.submiterText: '- -'}}
              </span>
              <span style="margin-left: 35px">提交时间：</span>
              <span>{{currentCertificate.review.submitTime ? 
                currentCertificate.review.submitTime: '- -'}}
              </span>
            </div>
            <div v-else>
              <span style="font-size: 13px">
                审核意见：
                {{currentCertificate.review.comment ? 
                  currentCertificate.review.comment: '- -'}}
              </span>
              <p>
                <span>
                  审核人：
                  {{currentCertificate.review.reviewerText ? 
                    currentCertificate.review.reviewerText: '- -'}} 
                </span>
                <span style="margin-left: 35px">
                  审核时间：
                  {{currentCertificate.review.reviewTime ? 
                    currentCertificate.review.reviewTime: '- -'}} 
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isFold" @click="isFold = false" class="header-right">
        <img style="width: 20px;height: 15px;margin-right: 5px;"
          src="../../../../assets/instmng/attendantlist/icon-attendant-unfold.png" alt="">
          展开查看
      </div>
      <div v-else-if="!isFold && (reviewType == 7 || reviewType == 11)" class="review-btn-container">
        <span class="status-button adopt-btn"  @click="handleReviewCert('approve')"
          v-if="isGlobalAdmin && (!currentCertificate.review.status || currentCertificate.review.status == 2)">
          <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-pass.png"
            alt="" />
          <span style="margin-left: 2px">通 过</span>
        </span>
        <span class="status-button"  v-if="isGlobalAdmin && !currentCertificate.review.status" 
          style="background: #e04a52; cursor: pointer" @click="handleReviewCert('reject')">
          <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-nopass.png"
            alt=""/>
          <span style="margin-left: 2px">驳 回</span>
        </span>
      </div>
    </div>
    <div v-if="!isFold && (reviewType != 7 && reviewType != 11)">
      <el-row type="flex" v-if="certificateList && certificateList.length" class="row-bg cert-wrap">
        <el-col :span="8" v-for="(item, idx) in certificateList" :key="idx">
          <div class="grid-content bg-purple cert-div">
            <div class="cert-image-container"
              :class="item.certificate.beOverdue ? 'expired-cert' : 'adopt-cert'">
              <div class="title-wrap">
                <img :src="item.type == 1 
                ? require('../../../../assets/instmng/attendantlist/icon-attendant-health-cert-head.png') 
                : require('../../../../assets/instmng/attendantlist/icon-attendant-cert-head.png')" 
                alt="">
                <span v-if="item.certificate.type == 1">健康证</span>
                <span v-else-if="item.certificate.type == 3">
                  {{item.certificate.name}}
                </span>
                <span v-else>
                  {{item.certificate.certTypeText}}
                </span>
              </div>
              <osis-cert v-if="item.certificate.type == 3" :certData="item.certificate" class="osis-cert" />
              <el-image v-else class="cert-image" :preview-src-list="previewImgList"
              :src="loadImage(item.certificate.imgPath)"></el-image>
              <div style="max-width: 250px">
              <div>
                <span>证书有效期：</span>
                <span v-if="item.certificate.permanent">长期有效</span>
                <span v-else>
                  {{formateDate(item.certificate.startDate)}}-{{formateDate(item.certificate.endDate)}}
                </span>
              </div>
              <div v-if="item.certificate.type == 3">
                <div class="review-time">
                  <span>同步时间：</span>
                  <span>
                    {{item.certificate.uploadTime ? item.certificate.uploadTime : '- -'}}
                  </span>
                </div>
                <div>
                  <span>来源：</span>
                  <span>
                    {{item.certificate.sourceText ? item.certificate.sourceText : '- -'}}
                  </span>
                </div>
              </div>
              <div v-else>
                <div class="review-time">
                  <span>审核时间：</span>
                  <span>
                    {{item.review && item.review.reviewTime ? item.review.reviewTime : '- -'}}
                  </span>
                </div>
                <div v-if="!item.certificate.beOverdue">
                  <span>审核人：</span>
                  <span>
                    {{item.review && item.review.reviewerText ? item.review.reviewerText : '- -'}}
                  </span>
                </div>
                <div v-else class="expired-cert-tag">过期证书需护工本人在APP中重新上传</div>
              </div>
            </div>
            <img class="review-status-icon" v-if="item.certificate.type != 3" :src="!item.certificate.beOverdue 
              ? require('../../../../assets/instmng/attendantlist/img-attendant-cert-adopt.png') 
              : require('../../../../assets/instmng/attendantlist/img-attendant-cert-expired.png')" 
              alt="">
          </div>
          </div>
        </el-col>
      </el-row>
      <el-empty v-else style="margin-bottom: 30px" :image-size="180"></el-empty>
    </div>
    <div v-else-if="!isFold && (reviewType == 7 || reviewType == 11)">
      <el-row type="flex" class="row-bg cert-wrap">
        <el-col :span="8">
          <div class="grid-content bg-purple cert-div">
            <div class="cert-image-container" :style="{'background': currentCertificate.review.status == 0 
              ? '#FFF' : currentCertificate.review.status == 2 ? '#F7E7EC' : '#E4EDFE'}">
              <div class="title-wrap">
                <img v-if="!isGlobalAdmin || currentCertificate.certificate.type == 1" alt="" :src="currentCertificate.certificate.type == 1 
                ? require('../../../../assets/instmng/attendantlist/icon-attendant-health-cert-head.png') 
                : require('../../../../assets/instmng/attendantlist/icon-attendant-cert-head.png')">
                <span v-if="currentCertificate.certificate.type == 1">健康证</span>
                <div v-if="!isGlobalAdmin">
                  <span v-if="currentCertificate.certificate.type == 3">
                    {{currentCertificate.certificate.name}}
                  </span>
                  <span v-if="currentCertificate.certificate.type == 2">
                    {{currentCertificate.certificate.certTypeText}}
                  </span>
                </div>
              </div>
              <el-image class="cert-image" :preview-src-list="previewImgList"
                :src="loadImage(currentCertificate.certificate.imgPath)" fit="cover">
              </el-image>
              <div v-if="currentCertificate.review.status == 0 && isGlobalAdmin">
                <div v-if="currentCertificate.certificate.type != 1">
                  <span>证书类型：</span>
                  <div style="margin: 12px 0">
                    <el-select style="width: 100%" v-model="currentCertificate.certificate.certTypeText" 
                      size="small" placeholder="请选择" @change="handleCertTypeChange">
                      <el-option v-for="item in trainingCertCfgList" :key="item.id"
                        :label="item.certText" :value="item.certText">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div class="cert-validity-wrap">
                    <span>证书有效期：</span>
                    <el-checkbox v-model="currentCertificate.certificate.permanent"
                    :true-label="1" :false-label="0">
                      长期有效
                    </el-checkbox>
                  </div>
                  <div style="margin: 12px 0">
                    <el-date-picker
                      style="width: 250px" size="small" v-model="expDate"
                      :disabled="currentCertificate.certificate.permanent == 1 ? true : false"
                      type="daterange" range-separator="至" @change="handleChangeDate"
                      start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div v-else  style="max-width: 250px">
                <div>
                  <span>证书有效期：</span>
                  <span v-if="currentCertificate.certificate.permanent">长期有效</span>
                  <span v-else>
                    {{formateDate(currentCertificate.certificate.startDate)}}
                    <span>-</span> 
                    {{formateDate(currentCertificate.certificate.endDate)}}
                  </span>
                </div>
                <div class="review-time">
                  <span>审核时间：</span>
                  <span>
                    {{currentCertificate.review.reviewTime ? 
                      currentCertificate.review.reviewTime : '- -'}}
                  </span>
                </div>
                <div>
                  <span>审核人：</span>
                  <span>
                    {{currentCertificate.review.reviewerText ? 
                      currentCertificate.review.reviewerText : '- -'}}
                  </span>
                </div>
              </div>
              <img class="review-status-icon" :src="currentCertificate.review.status == 1 
              ? require('../../../../assets/instmng/attendantlist/img-attendant-cert-adopt.png')
              : currentCertificate.review.status == 2 
              ? require('../../../../assets/instmng/attendantlist/img-attendant-cert-refuse.png')
              : require('../../../../assets/instmng/attendantlist/img-attendant-cert-to-review.png')" 
              alt="">
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="extranetcert-text-wrap">
        <span>其他电子证书</span>
      </div>
      <el-row type="flex" v-if="otherCertificateList && otherCertificateList.length" class="row-bg cert-wrap">
        <el-col :span="8" v-for="(item, idx) in otherCertificateList" :key="idx">
          <div class="grid-content bg-purple cert-div">
            <div class="cert-image-container"
              :class="item.certificate.beOverdue ? 'expired-cert' : 'adopt-cert'">
              <div class="title-wrap">
                <img :src="item.certificate.type == 1 
                ? require('../../../../assets/instmng/attendantlist/icon-attendant-health-cert-head.png') 
                : require('../../../../assets/instmng/attendantlist/icon-attendant-cert-head.png')" 
                alt="">
                <span v-if="item.certificate.type == 1">健康证</span>
                <span v-else-if="item.certificate.type == 3">
                  {{item.certificate.name}}
                </span>
                <span v-else>
                  {{item.certificate.certTypeText}}
                </span>
              </div>
              <osis-cert v-if="item.certificate.type == 3" :certData="item.certificate" class="osis-cert" />
              <el-image v-else class="cert-image" :src="loadImage(item.certificate.imgPath)"></el-image>
              <div style="max-width: 250px">
                <div>
                  <span>证书有效期：</span>
                  <span v-if="item.certificate.permanent">长期有效</span>
                  <span v-else>
                    {{formateDate(item.certificate.startDate)}}-{{formateDate(item.certificate.endDate)}}
                  </span>
                </div>
                <div v-if="item.certificate.type == 3">
                  <div class="review-time">
                    <span>同步时间：</span>
                    <span>
                      {{item.certificate.uploadTime ? item.certificate.uploadTime : '- -'}}
                    </span>
                  </div>
                  <div>
                    <span>来源：</span>
                    <span>
                      {{item.certificate.sourceText ? item.certificate.sourceText : '- -'}}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <div class="review-time">
                    <span>审核时间：</span>
                    <span>
                      {{item.review && item.review.reviewTime ? item.review.reviewTime : '- -'}}
                    </span>
                  </div>
                  <div v-if="!item.certificate.beOverdue">
                    <span>审核人：</span>
                    <span>
                      {{item.review && item.review.reviewerText ? item.review.reviewerText : '- -'}}
                    </span>
                  </div>
                  <div v-else class="expired-cert-tag">过期证书需护工本人在APP中重新上传</div>
                </div>
              </div>
              <img class="review-status-icon" v-if="item.certificate.type != 3" :src="!item.certificate.beOverdue 
              ? require('../../../../assets/instmng/attendantlist/img-attendant-cert-adopt.png') 
              : require('../../../../assets/instmng/attendantlist/img-attendant-cert-expired.png')" 
              alt="">
            </div>
          </div>
        </el-col>
      </el-row>
      <el-empty v-else style="margin-bottom: 30px" :image-size="180"></el-empty>
    </div>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import OsisCert from './OsisCertificate.vue'

export default {
	props: ["reviewType", "certificateList", "trainingCertCfgList", "isGlobalAdmin",
    "currentCertificate", "otherCertificateList"],

  components: {
    "osis-cert": OsisCert
  },

  data() {
    return {
        value: '',
        checked: true,
        isFold: false,
        reviewStatus: 1, //审核状态
        expDate: ''
    }
  },

  computed: {
    loadImage() {
      return (logoPath) => {
        return logoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, logoPath)
          : '';
      };
    },

    formateDate() {
      return function (date) {
        if (date) return this.dateUtil.dateFormat(date, "YYYY-MM-DD", ".");
      };
    },

    previewImgList() {
      let imageList = [];
      if (this.certificateList && this.certificateList.length) {
         imageList = this.getPreviewList(this.certificateList);
      }

      if(this.currentCertificate && this.currentCertificate.certificate.imgPath) {
        imageList.push(this.commonUtil.fillUrlArgments
          (this.commonUrl.URL_DOWNLOAD_FILE, this.currentCertificate.certificate.imgPath))
      }

      if(this.otherCertificateList && this.otherCertificateList.length) {
        imageList.concat(this.getPreviewList(this.otherCertificateList))
      }

      return imageList;
    }
  },

  watch: {
    reviewType: {
      immediate:true,
      handler(val) {
        this.isFold = val == 7 || val == 11 ? false : true ;
      }
    },

    currentCertificate: {
      immediate:true,
      handler(obj) {
       this.expDate = obj && (!obj.certificate.permanent && obj.certificate.startDate) && obj.certificate.endDate ? 
        [obj.certificate.startDate, obj.certificate.endDate] : '';
      }
    }
  },

  methods: {
    handleReviewCert(reviewStatus) {
      if (!this.currentCertificate.certificate.permanent && reviewStatus == 'approve' 
        && !this.expDate ){
        this.$message.warning('请选择证书有效期');
        return
      }

      if (!this.currentCertificate.certificate.permanent && reviewStatus == 'approve' &&
        Date.parse(this.currentCertificate.certificate.endDate) < new Date().getTime()){
        this.$message.warning('请重新选择证书有效期！结束日期应大于今日');
        return
      }

      this.currentCertificate.certificate.startDate = this.expDate
        ? this.dateUtil.dateFormat(this.expDate[0]) : null;
        this.currentCertificate.certificate.endDate = this.expDate
        ? this.dateUtil.dateFormat(this.expDate[1]): null;
      this.$emit("handle-cert-review", reviewStatus, this.currentCertificate);
    },

    //证书类型绑定类别名称,避免绑定证书类别id时为空值时显示默认值0
    handleCertTypeChange(val) {
      if (!val) return;
      this.currentCertificate.certificate.certCfgId = 
        Util.searchKeyWithValueInArr("certText", val, this.trainingCertCfgList).id;
    },

    //限制证书有效期结束日期需大于今天
    handleChangeDate(dateArr) {
      if (dateArr && dateArr.length && dateArr[1].getTime() < new Date().getTime()){
        this.$message.warning('请重新选择证书有效期！结束日期应大于今日');
        this.expDate = null;
      }
    },

    getPreviewList(list) {
      let previewList = [];
      list.forEach((item)=> {
        let certItem = item.certificate ? item.certificate : item;
        if(certItem.imgPath) {
          previewList.push(this.commonUtil.fillUrlArgments
          (this.commonUrl.URL_DOWNLOAD_FILE, certItem.imgPath))
        }
      })
      return previewList;
    }
  }
}
</script>

<style scoped>
.certInfo-wrap {
  background: #f7f9fe;
  padding-left: 25px;
  margin: 0 25px 20px 25px;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f7f9fe;
}

.sticky {
  position: sticky;
  top: 50px;
  z-index: 300;
}

.certInfo-wrap .header {
  margin: 30px 0;
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  color: #000000;
  font-size: 22px;
  flex: 1;
}

.header-image {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}

.header-right {
  background: #F1F5FF;
  height: 120px;
  color: #3E7EF5;
  width: 177px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.review-status-text-wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1BAA60;
  margin: 10px 0 3px 0;
}

.review-text{
  color: #657180;
  font-size: 14px;
  background: rgba(186,186,186,0.1);
  margin-left: 32px;
  padding: 11px 20px 11px 6px;
  font-weight: 400;
}

.review-text p{
  margin: 0;
  margin-top: 10px;
  font-size: 14px;
}

.cert-wrap {
  flex-wrap: wrap;
  padding: 0 30px 20px 80px;
}

.cert-div {
  margin: 0 13px 13px 0;
}
.cert-image-container {
  width: fit-content;
  background: #E4EDFE;
  border-radius: 8px;
  border: 1px solid #DEDEDE;
  display: flex;
  position: relative;
  flex-direction: column;
  color: #657180;
  font-size: 14px;
  padding: 0 26px 30px 26px;
}

.expired-cert{
  background: #EAEAEA;
}

.adopt-cert {
  background: #E4EDFE;
}

.expired-cert-tag{
  color: #FF4D4F;
}

.extranetcert-text-wrap {
  margin: 20px 40px 20px 80px;
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.title-wrap {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  margin-top: 25px;
  justify-content: center;
}
.title-wrap img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.cert-image {
  width: 250px;
  height: 182px;
  margin: 15px 0 25px 0;
}

.review-time {
  margin: 15px 0;
}

.review-status-icon {
  widows: 72px;
  height: 59px;
  position: absolute;
  right: 0;
}

.cert-validity-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px;
}

.drop-icon {
  width: 28px;
  display: inline-block;
  color: #FFFFFF;
  height: 100%;
  background: #66B1FE;
  line-height: 39px;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
}

.review-btn-container {
  padding-right: 20px;
  width: 240px;
  margin-top: 37px;
}
.status-button {
  display: inline-block;
  width: 98px;
  height: 31px;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
}

.review-btn-icon {
  width: 18px;
  height: 20px;
  vertical-align: middle;
}

.adopt-btn {
  background: #3e7ef6;
  cursor: pointer;
  margin-right: 25px;
}

.circle-dot {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 10px;
  color: #999999;
  background: #1BAA60;
}

.routine-status {
  background: #1BAA60;
}
.refuse-status {
  background: #FF0909;
}

.routine-text {
  color: #1BAA60;
}
.refuse-text {
  color: #FF0909;
}

.osis-cert {
  margin: 15px 0 25px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/attendantReviewDetails/AttendantReviewCertInfo.vue